import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '../i18n';
import axios from 'axios'
import { auth } from '@/services/api.js'
import router from '@/router/index'

Vue.use(Vuex);

export default new Vuex.Store({
    
    state: {
        layout: 'app',
        user: {
            loggedIn: false,
            tokenExpiresAt: '',
            token: '',
            name:'',
            id:'',
            perfil:0,
            permisosOpcionMenu: [],
            opcionesMenu: [],
            empresa_id:0,
            empresa:''
        },
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
        dark_mode: 'light',
        locale: null,
        menu_style: 'vertical',
        layout_style: 'full',
        countryList: [
            { code: 'zh', name: 'Chinese' },
            { code: 'da', name: 'Danish' },
            { code: 'en', name: 'English' },
            { code: 'fr', name: 'French' },
            { code: 'de', name: 'German' },
            { code: 'el', name: 'Greek' },
            { code: 'hu', name: 'Hungarian' },
            { code: 'it', name: 'Italian' },
            { code: 'ja', name: 'Japanese' },
            { code: 'pl', name: 'Polish' },
            { code: 'pt', name: 'Portuguese' },
            { code: 'ru', name: 'Russian' },
            { code: 'es', name: 'Spanish' },
            { code: 'sv', name: 'Swedish' },
            { code: 'tr', name: 'Turkish' }
        ]
    },
    mutations: {
        setLayout(state, payload) {
            state.layout = payload;
        },
        toggleSideBar(state, value) {
            state.is_show_sidebar = value;
        },
        toggleSearch(state, value) {
            state.is_show_search = value;
        },
        toggleLocale(state, value) {
            value = value || 'en';
            i18n.locale = value;
            localStorage.setItem('i18n_locale', value);
            state.locale = value;
        },

        setUser (state, payload) {
            Object.assign(state.user, payload)
        },
        saveLoggedState (state, status) {
            state.user.loggedIn = status
        },
        saveLoginNameState (state, Name) {
            state.user.Name = Name
        },
        saveLoginIdState (state, Id) {
            state.user.Id = Id
        },
        saveLoginPerfilState (state, perfil) {
            state.user.perfil = perfil
        },
        saveLoginIdEmpresaState (state, idempresa) {
            state.user.empresa_id = idempresa
        },
        saveLoginEmpresaState (state, empresa) {
            state.user.empresa = empresa
        },
        saveLoginTokenState (state, token) {
            state.user.token = token
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        },
        saveOpcionesMenu (state, menu) {
            state.user.opcionesMenu = menu
        },
        savePermisosOpcionMenu (state, permisos) {
            state.user.permisosOpcionMenu = permisos
        },

        toggleDarkMode(state, value) {
            //light|dark|system
            value = value || 'light';
            localStorage.setItem('dark_mode', value);
            state.dark_mode = value;
            if (value == 'light') {
                state.is_dark_mode = false;
            } else if (value == 'dark') {
                state.is_dark_mode = true;
            } else if (value == 'system') {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector('body').classList.add('dark');
            } else {
                document.querySelector('body').classList.remove('dark');
            }
        },

        toggleMenuStyle(state, value) {
            //horizontal|vertical|collapsible-vertical
            value = value || '';
            localStorage.setItem('menu_style', value);
            state.menu_style = value;
            if (!value || value === 'vertical') {
                state.is_show_sidebar = true;
            } else if (value === 'collapsible-vertical') {
                state.is_show_sidebar = false;
            }
        },

        toggleLayoutStyle(state, value) {
            //boxed-layout|large-boxed-layout|full
            value = value || '';
            localStorage.setItem('layout_style', value);
            state.layout_style = value;
        }
    },
    getters: {
        layout(state) {
            return state.layout;
        },
        user(state) {
            return state.user;
        }
    },
    actions: {
        async logout ({ commit }, error) {
            try {
            
            if(error != 401){
                await auth.logout()
            }

            commit('setUser', {loggedIn: false,tokenExpiresAt: '',token: '',name:'',id:'',perfil:0,permisosOpcionMenu: [],opcionesMenu: [],empresa:''})
            
            Vue.prototype.$session.remove('user_token')
            Vue.prototype.$session.remove('user_name')
            Vue.prototype.$session.remove('user_perfil')
            Vue.prototype.$session.remove('user_menus')
            Vue.prototype.$session.remove('user_permisos')
            Vue.prototype.$session.remove('user_id')
            Vue.prototype.$session.remove('user_empresa_id')
            Vue.prototype.$session.remove('user_empresa')

            router.push('/admin/login')
            
        } catch (error) {
            console.log('store logout',error)
            commit('setUser', {loggedIn: false,tokenExpiresAt: '',token: '',name:'',id:'',perfil:0,permisosOpcionMenu: [],opcionesMenu: [],empresa:''})
            Vue.prototype.$session.remove('user_token')
            Vue.prototype.$session.remove('user_name')
            Vue.prototype.$session.remove('user_perfil')
            Vue.prototype.$session.remove('user_menus')
            Vue.prototype.$session.remove('user_permisos')
            Vue.prototype.$session.remove('user_id')
            Vue.prototype.$session.remove('user_empresa_id')
            Vue.prototype.$session.remove('user_empresa')

        } 
        }
    },
    modules: {}
});
